import { render, staticRenderFns } from "./auth-form.vue?vue&type=template&id=cabba21c"
import script from "./auth-form.vue?vue&type=script&lang=js"
export * from "./auth-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports